// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"661":"33afab832796a12e1a51","969":"b456845ad03f2c0aec1a"}[chunkId] + ".bundle.js";
};